import React from 'react';
import { Form, Input } from 'antd';

const FormInput = ({ label, name, placeholder, errors, rules, password }) => {
    return (
        <Form.Item
            label={label}
            name={name}
            rules={[
                ...rules,
                () => ({
                    validator() {
                        console.log(errors);
                        if (errors != undefined) {
                            console.log(errors);
                            if (errors.hasOwnProperty(name)) {
                                return Promise.reject(errors[name]);
                            }
                        }
                        return Promise.resolve();
                    }
                })
            ]}
        >
            {password ? (
                <Input.Password autoFocus placeholder={placeholder} />
            ) : (
                <Input autoFocus placeholder={placeholder} />
            )}
        </Form.Item>
    );
};

export default FormInput;
